<template>
  <div class="container" v-if="footerLanguages.length>1 && $c('show_language_selection')">
    <div class="lang pointer"
        role="button"
        tabindex="0"
        @keydown="ariaClick"
        :class="[{'selected':selected(lang)},brandClass()]"
        @click="selectLanguage(lang)"
        v-for="(lang, index) in footerLanguages" :key="`lang-${index}`" >
      {{$toUpperCase(lang)}}
    </div>
  </div>
</template>

<script>
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineComponent } from 'vue';
export default defineComponent({
  mixins: [oneUtils.accessibilityMixin],
  name: "LanguageSelection",
  inject:['$c', '$t', 'brandClass', '$toUpperCase'],
  computed: {
    footerLanguages(){
      const config = this.$store.getters.getConfigurations.client ? this.$store.getters.getConfigurations.client.config : null;
      if(!config){
        return [];
      }
      const configForBrand = config.brand && config.brand[this.$store.getters.getConfigurationParams.brand] && config.brand[this.$store.getters.getConfigurationParams.brand].country ? config.brand[this.$store.getters.getConfigurationParams.brand].country[this.$store.getters.getConfigurationParams.country] : null;
      if(configForBrand){
        return configForBrand.language ? Object.keys(configForBrand.language) : [];
      }
      const configDefault = config.country ? config.country[this.$store.getters.getConfigurationParams.country] : null;

      if(configDefault){
        return configDefault.language ? Object.keys(configDefault.language) : [];
      }

      return [];
    }
  },
  methods: {
    selected(language){
      return this.$store.getters.getConfigurationParams.language==language;
    },
    selectLanguage(language) { 
      if (window['$startupwebcomponent']){
        oneUtils.utils.showGlobalLoader();
         const event = new CustomEvent("WEB_COMPONENT_CHANGE_LANGUAGE", {
          detail: {
            oneid_new_language: language
          }
        });
        window.dispatchEvent(event);
      }else{
        oneUtils.utils.updateQueryParamsByKey("language", language);
        const newParams = {...this.$store.state.configurationParams};
        newParams.language = language;
        this.$store.dispatch("setupConfigParams", newParams);
      }
      // [GCDM-237721] Implementation 
      window['epaas'].api.setLocale(this.$c('_tenant_locale'));
    }
  }
});
</script>

<style lang="scss" scoped>
@import './styles/_variables.scss';
  .container{
    // width: 100%;
    display: flex;
    font-weight: 700;
    margin-bottom: 24px;
    .lang{
      color: $grey;
      margin-right: 16px;
      &:hover{
        color: $black;
        &.__d{
          color: white;
        }
        &.__rr {
          color: white;
        }
      }
      &.selected{
        color: $black;
        &.__d{
          color: white;
        }
        &.__rr {
          color: white;
        }
        text-decoration: underline;
      }
    }
  }
</style>
